import { CallCodeModel, ICallCodeModel } from '@common/models/CallCodeModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class CallCodeService {
  private static baseUrl: string = '/api/callcode';

  static tags = {
    upsertCallCode: 'upsertCallCode',
    deleteCallCode: 'deleteCallCode',
  };

  static upsertCallCode = (
    data: ICallCodeModel,
    options?: ServiceMethodOptions,
  ): Promise<CallCodeModel> => {
    return trackPromise(
      new Promise<ICallCodeModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<ICallCodeModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Call Code updated', options);
            resolve(new CallCodeModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Call Code', options);
            reject(err);
          });
      }),
      this.tags.upsertCallCode,
    );
  };

  static deleteCallCode = (
    callCodeId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${callCodeId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess('Call Code has been deleted', options);
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Call Code', options);
            reject(err);
          });
      }),
      this.tags.deleteCallCode,
    );
  };
}
